import EmployeeProfileSlideout from "./EmployeeProfileSlideout";

export default EmployeeProfileSlideout;
